import { Person } from '../platformui/';
export default Person;
